// JS
import React from 'react';
import { randomId } from '../shared/utils';

// COMPONENT
const Button = ({
  gaBlockTitle,
  gaBlockName,
  gaBlockId,
  buttonColour = 'white',
  buttonGroup = false,
  buttonLink,
  buttonLinkText,
  buttonAdditionalClasses,
  buttonSlotNumber = 1
}) => {
  const uniqueId = randomId();
  const gaTracking = gaBlockTitle && gaBlockName && gaBlockId;
  const buttonColours = {
    white: `block w-[170px] lg:!w-[270px] h-auto py-8 px-8 text-xs lg:text-md text-white text-center font-bold uppercase border border-solid border-black bg-black transition ease-in-out duration-400 ${
      buttonGroup
        ? 'group-hover:!text-black group-hover:!bg-white'
        : 'hover:!text-black hover:!bg-white hover:!border-black'
    } tracking-widest`,
    black: `block w-[170px] lg:!w-[270px] h-auto py-8 px-8 text-xs lg:text-md text-black text-center font-bold uppercase border border-solid border-black bg-transparent transition ease-in-out duration-400 ${
      buttonGroup
        ? 'group-hover:text-white group-hover:!bg-black'
        : 'hover:text-white hover:!bg-black'
    } tracking-widest`,
    heroVideo: `block w-full lg:w-auto h-auto py-5 px-12 text-md text-white text-center font-bold uppercase border border-solid border-white bg-transparent transition ease-in-out duration-400 ${
      buttonGroup
        ? 'group-hover:!text-black group-hover:!bg-white'
        : 'hover:!text-black hover:!bg-white'
    } tracking-widest`
  };

  return (
    <div className="flex justify-center">
      <button
        onClick={(e) => {
          e.preventDefault();
          if (e.metaKey || e.ctrlKey) {
            window.open(buttonLink, '_blank');
          } else {
            window.open(buttonLink, '_self');
          }
        }}
        id={'button-id-' + uniqueId}
        className={
          buttonColours[buttonColour] +
          (buttonAdditionalClasses?.classes
            ? ' ' + buttonAdditionalClasses.classes
            : '')
        }
        data-name={gaTracking && gaBlockTitle}
        data-creative={gaTracking && gaBlockName}
        data-id={gaTracking && gaBlockId}
        data-position={gaTracking && 'button-slot-' + buttonSlotNumber}
        data-type={gaTracking && 'banner-button'}
      >
        {buttonLinkText}
      </button>
    </div>
  );
};

export default Button;
